import { BaseModel } from "../../normalized/models";

export class Group extends BaseModel {
    id: number;
    name: string;
}
